import {
  filterProductOptions,
  filterProductOptionsV2,
} from "./product-filtering"

const displayOptionHeading = (wizardData, pref, choices) => {
  let heading = wizardData?.heading?.title
  const selectedValue = choices[pref]?.value

  if (wizardData?.heading?.titles?.options) {
    const titleOptions = filterProductOptionsV2(
      wizardData.heading.titles.options,
      choices
    )
    if (titleOptions.length) {
      heading = titleOptions[0].label
    }
  }

  if ((pref === "ef" || pref === "ef2") && selectedValue) {
    const selectedOption = (wizardData?.options || []).find(
      (opt) => opt.value === selectedValue
    )

    if (selectedOption) {
      const filteredOptions = filterProductOptions(
        wizardData?.options || [],
        choices,
        true
      )
      if (filteredOptions.length > 1) {
        heading = `${heading} (${selectedOption.display_name ?? selectedOption.value})`
      }
    }
  }

  return heading
}

export default displayOptionHeading
